export default __webpack_public_path__ + "static/media/bordeaux.fc298414.png";